/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconRaisedHand(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8.674 0h.66c.51 0 .957.272 1.204.678a2.73 2.73 0 0 1 2.308 1.997 2.75 2.75 0 0 1 2.29 2.711v5.91A4.705 4.705 0 0 1 10.432 16H8.92a7.34 7.34 0 0 1-3.602-.944l-4.351-2.45a1.409 1.409 0 0 1-.53-1.933l.243-.419a2.727 2.727 0 0 1 3.725-.998l.003.001V4.068a2.75 2.75 0 0 1 2.325-2.717A2.069 2.069 0 0 1 8.674 0zM6.716 2.9a1.25 1.25 0 0 0-.807 1.168V9.69a1.25 1.25 0 0 1-1.875 1.083l-.378-.218a1.227 1.227 0 0 0-1.676.449l-.196.34 4.271 2.405a5.841 5.841 0 0 0 2.866.751h1.51a3.205 3.205 0 0 0 3.205-3.204v-5.91c0-.534-.335-.99-.807-1.169v3.124a.75.75 0 0 1-1.5 0V2.878a1.23 1.23 0 0 0-.806-.68v5.143a.75.75 0 0 1-1.5 0V1.5h-.349a.567.567 0 0 0-.458.233V7.34a.75.75 0 1 1-1.5 0V2.899z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13.333 0h1a2 2 0 0 1 1.733 1h.6a3 3 0 0 1 3 3H20a3 3 0 0 1 3 3v10a7 7 0 0 1-7 7h-2.292c-1.891 0-3.75-.488-5.397-1.415l-6.602-3.718a2 2 0 0 1-.75-2.743l.366-.635a4 4 0 0 1 5.464-1.464l.211.121V5a3 3 0 0 1 3-3h.504a3.001 3.001 0 0 1 2.83-2zM10.5 4H10a1 1 0 0 0-1 1v10.012a1.5 1.5 0 0 1-2.25 1.3l-.96-.555a2 2 0 0 0-2.733.732l-.367.635 6.602 3.718A9.001 9.001 0 0 0 13.708 22H16a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1h-.5v5a1 1 0 1 1-2 0V3.5l.001-.051A1 1 0 0 0 16.667 3H16v8a1 1 0 1 1-2 0V2h-.667a1 1 0 0 0-.834.45l.001.05V11a1 1 0 1 1-2 0V4z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconRaisedHand is deprecated and will be archived soon. Use IconRaisedHand instead.
 */
export function Experimental__IconRaisedHand(props) {
  return /*#__PURE__*/React.createElement(IconRaisedHand, props);
}